import {Injectable} from '@angular/core';
import {ApiService} from "./api.service";
import {StorageService} from "./storage.service";
import {DomSanitizer} from "@angular/platform-browser";

@Injectable({
    providedIn: 'root'
})
export class LangService {

    data: any = {};

    constructor(
        private apiService: ApiService,
        private storageService: StorageService,
        private sanitizer: DomSanitizer
    ) {
    }

    async init(langCode: string) {
        return this.apiService.doRequest('translations', 'GET', [])
            .then((resp) => {
                if (resp.data.length > 0) {

                    resp.data.forEach((langItem: any) => {
                        this.data[langItem.key] = langItem.value;
                    })

                    this.storageService.set('translations', JSON.stringify(this.data));
                }
            })
    }
    
    /**
     * Get Lang Value
     * @param key
     * @param defValue
     */
    get(key: string, defValue = '') {
        return (this.data[key] !== undefined)  ? this.data[key] : defValue;
    }

    getHtml(key: string, defValue = '') {
        if (this.data[key] === undefined) {
            return defValue
        }
        return this.sanitizer.bypassSecurityTrustHtml(this.data[key]);
    }

    requiredField(slug : any) {
        let requiredText = "This :field is required";

        if( this.data['error.field_required'] === undefined || this.data[slug] === undefined) {
            return requiredText;
        }

        return this.data['error.field_required'].replace(':field', this.data[slug]);
    }

    minLengthField(slug : any, length : number = 2) {
        let minLengthText = "The field must have at least :length characters";

        if( this.data['error.minlength'] === undefined || this.data[slug] === undefined) {
            return minLengthText;
        }

        return this.data['error.minlength']
            .replace(':field', this.data[slug])
            .replace(':length', length);
    }
}
